import { render } from "./404.vue?vue&type=template&id=6b3aeb0e&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=6b3aeb0e&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3aeb0e"],['__file',"src/views/404.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b3aeb0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b3aeb0e', __exports__)) {
    console.log('reload')
    api.reload('6b3aeb0e', __exports__)
  }
  
  module.hot.accept("./404.vue?vue&type=template&id=6b3aeb0e&scoped=true", () => {
    console.log('re-render')
    api.rerender('6b3aeb0e', render)
  })

}


export default __exports__